<template>
  <div>
    <div>
      <el-button
        v-permission="Auth.instrumentStockIn"
        type="primary"
        size="small"
        @click="ItemStock(1)"
        >入库</el-button
      >
      <!-- <el-button type="primary" size="small" @click="ItemStock(2)"
        >出库</el-button
      >
      <el-button type="primary" size="small" @click="ItemStock(2, true)"
        >发往钻井</el-button
      > -->
    </div>
    <el-table
      :data="items"
      border
      size="small"
      class="mt-10"
      v-loading="loading"
      ref="table"
    >
      <el-table-column
        fixed="left"
        align="center"
        label="编码"
        prop="code"
      ></el-table-column>
      <el-table-column align="center" label="发出方">
        <template slot-scope="scope">
          {{
            scope.row.from_well.well_number || scope.row.from_base.name || '无'
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="user.name" label="发起人">
      </el-table-column>
      <el-table-column align="center" prop="send_at" label="发出时间">
      </el-table-column>
      <el-table-column align="center" label="接收方">
        <template slot-scope="scope">
          {{ scope.row.to_well.well_number || scope.row.to_base.name }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="receive_user.name" label="接收人">
      </el-table-column>
      <el-table-column align="center" prop="receive_at" label="接收时间">
      </el-table-column>
      <el-table-column align="center" prop="number" label="数量">
      </el-table-column>
      <el-table-column align="left" label="备注">
        <template slot-scope="scope">
          <div v-html="scope.row.remark"></div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <ItemStatus
            :status="scope.row.status"
            model="noCodeProduct"
          ></ItemStatus>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="170"
        fixed="right"
      >
        <template slot-scope="scope">
          <div
            v-if="
              template.category == 2 &&
              scope.row.status == 1 &&
              scope.row.apply_id == 0 &&
              $store.state.userInfo.base_id
            "
            v-permission="Auth.instrumentStockManage"
          >
            <el-popconfirm
              v-if="
                scope.row.from_base_id == $store.state.userInfo.base_id &&
                scope.row.status == 1
              "
              title="确认撤回吗？"
              @confirm="itemStockRecall(scope.row, scope.$index)"
            >
              <el-link
                slot="reference"
                type="danger"
                class="font-12 ml-5"
                :underline="false"
                >撤回</el-link
              >
            </el-popconfirm>
            <el-link
              v-if="scope.row.receive_base_id == $store.state.userInfo.base_id"
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              @click="itemStockReject(scope.row, scope.$index)"
              >拒收</el-link
            >
            <el-popconfirm
              v-if="
                scope.row.receive_base_id == $store.state.userInfo.base_id &&
                scope.row.drill_well_id == 0
              "
              title="确认入库该成品吗？"
              @confirm="itemStockIn(scope.row, scope.$index)"
            >
              <el-link
                slot="reference"
                type="danger"
                class="font-12 ml-5"
                :underline="false"
                >确认入库</el-link
              >
            </el-popconfirm>
            <el-popconfirm
              v-if="
                scope.row.receive_base_id == $store.state.userInfo.base_id &&
                scope.row.drill_well_id > 0
              "
              title="确认该成品已从钻井返回吗？"
              @confirm="itemReceiveConfirm(scope.row, scope.$index)"
            >
              <el-link
                slot="reference"
                type="danger"
                class="font-12 ml-5"
                :underline="false"
                >确认接收</el-link
              >
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @size-change="handleSizeChange"
        @current-change="getData"
        layout="total,sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <StockFormer
      :model="model"
      :show.sync="stockFormerVisible"
      @callback="getData"
    ></StockFormer>
  </div>
</template>

<script>
import {
  productList,
  productStockIn,
  productReceiveComfirm,
  productRecall,
  productReject,
} from '@/service/getData'
import StockFormer from './StockFormer.vue'

export default {
  components: {
    StockFormer,
  },
  props: {
    template: Object,
    filter: Object,
  },
  data() {
    return {
      items: [],
      total: 0,
      model: {},
      stockFormerVisible: false,
      editIndex: 0,
      loading: false,
    }
  },
  methods: {
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let data = this.clone(this.filter)
      data.page -= 1
      if (data.send_date && data.send_date.length == 2) {
        data.send_start_date = data.send_date[0]
        data.send_end_date = data.send_date[1]
      }
      if (data.receive_date && data.receive_date.length == 2) {
        data.receive_start_date = data.receive_date[0]
        data.receive_end_date = data.receive_date[1]
      }
      this.loading = true
      let res = await productList(data)
      if (res.status == 0) {
        this.items = res.data.list
        this.total = res.data.count
        this.loading = false
      }
    },
    handleSizeChange(size) {
      this.filter.size = size
      this.filter.page = 1
      this.getData()
    },

    ItemStock(t = 1, towell = false) {
      let fromBaseid = ''
      if (t == 2 && this.$store.state.userInfo.base_id > 1) {
        fromBaseid = this.$store.state.userInfo.base_id
      }
      this.model = {
        name: this.template.name,
        product_template_id: this.template.id,
        category: this.template.category,
        from_base_id: fromBaseid, //出库
        to_base_id: '',
        stock_type: t, //出库/入库
        code_type: this.template.code_type,
        towell: towell,
        number: 0,
      }
      this.stockFormerVisible = true
    },

    async itemStockIn(item, index) {
      let res = await productStockIn({ id: item.id })
      if (res.code == 0) {
        this.$set(this.items, index, res.data)
        this.$emit('baseCheck')
      }
    },

    async itemReceiveConfirm(item, index) {
      let res = await productReceiveComfirm({ id: item.id })
      if (res.code == 0) {
        this.$set(this.items, index, res.data)
        this.$emit('baseCheck')
      }
    },

    // 撤回
    async itemStockRecall(item, index) {
      let res = await productRecall({
        id: item.id,
      })
      if (res.code == 0) {
        this.$set(this.items, index, res.data)
        this.$notify.success('已撤回！')
      }
    },

    //拒收
    itemStockReject(item, index) {
      this.$prompt('拒收原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (value) => {
          return !!value
        },
        inputErrorMessage: '拒收原因不能为空',
      }).then(async ({ value }) => {
        let res = await productReject({
          id: item.id,
          remark: value,
        })
        if (res.code == 0) {
          this.$set(this.items, index, res.data)
          this.$notify.success('已拒收！')
          this.$emit('baseCheck')
        }
      })
    },
  },
}
</script>

<style scoped>
.table-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>